const FONTS_ALIGN = 'left';

export { FONTS_ALIGN as F };
